virtual function void build_phase(uvm_phase phase);
  {{ analysisPortHandle.identifier }} = new("{{ analysisPortHandle.identifier }}", this);

{{#each parameters}}
  if ({{ name }} == {{ defaultValue }}) begin
    `uvm_fatal(get_type_name(), "Must specify the {{ name }} parameter.")
  end
{{/each}}
endfunction
